// import 'babel-polyfill';
import 'objectFitPolyfill';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';

import './menu';
import './view-initalizer';
